<template>
  <div class="new-dashboard">
    <WalletWidget
      class="new-dashboard__wallet-widget"
      :currentAsset="currentToken"
      :tronSum="sumTron"
      :isShowWithdrawal="isShowWithdrawalWidget"
      @[commonEvents.assetChangeEvent]="setCurrentAsset"
      @[commonEvents.walletTopUpEvent]="walletTopUpHandler"
      @[commonEvents.walletWithdrawalEvent]="wizdrawalHandler"
    />
    <componnet
      :is="getCurrentComponent"
      class="new-dashboard__operations-widget"
      @refreshBalances="loadBalances"
    />
    <CryptoChart
      class="new-dashboard__chart-widget"
    />
    <LastTransactionsWidget
      class="new-dashboard__history-widget"
      :currentAsset="currentToken"
    />
  </div>
</template>

<script>
  import WalletWidget from '../widgets/WalletWidget.vue'
  import MakeTopupWidget from '../widgets/MakeTopupWidget.vue'
  import MakeWithdrawalWidget from '../widgets/WithdrawalWidget'
  import LastTransactionsWidget from '../widgets/LastTransactionsWidget.vue'
  import CryptoChart from '../widgets/CryptoChart.vue'

  import { mapGetters, mapActions } from 'vuex'
  import { vuexTypes } from '@vuex/types'
  import { commonEvents } from '@js/events/common_events'
  import { PREFERRED_ASSET_CODES } from '@utils/consts'

  const OPERATIONS_WIDGETS = {
    MAKE_TOPUP: 'MakeTopupWidget',
    WIZDRAWAL: 'MakeWithdrawalWidget'
  }

  export default {
    name: 'dashboard',
    components: {
      WalletWidget,
      MakeTopupWidget,
      MakeWithdrawalWidget,
      LastTransactionsWidget,
      CryptoChart
    },
    data: _ => ({
      OPERATIONS_WIDGETS,
      commonEvents,
      currentToken: null,
      currentActiveOperationWidget: OPERATIONS_WIDGETS.MAKE_TOPUP
    }),
    async created () {
      await this.setCurrentAsset(this.currentAsset)
    },
    computed: {
      ...mapGetters([
        vuexTypes.accountBalances,
        vuexTypes.currentAsset,
        vuexTypes.approverData
      ]),
      sumTron () {
        const balances = this.accountBalances || {}
        const sum = PREFERRED_ASSET_CODES.reduce((total, code) => {
          const white = balances[code]
          const grey = balances[`${code}D`]
          return total + (Number(white && white.balance) || 0) + (Number(grey && grey.balance) || 0)
        }, 0)

        return sum.toFixed(6).replace(/0+$/, '').replace(/\.$/, '')
      },
      getCurrentComponent () {
        switch (this.currentActiveOperationWidget) {
          case OPERATIONS_WIDGETS.MAKE_TOPUP:
            return MakeTopupWidget
          case OPERATIONS_WIDGETS.WIZDRAWAL:
            return this.isShowWithdrawalWidget ? MakeWithdrawalWidget : null
        }
      },
      isShowWithdrawalWidget () {
        return this.approverData.approval_level === 1
      }
    },
    methods: {
      ...mapActions({
        loadBalances: vuexTypes.GET_ACCOUNT_BALANCES,
        commitAsset: vuexTypes.COMMIT_CURRENT_ASSET
      }),
      setCurrentAsset (value) {
        // const codes = Object.keys(this.accountBalances)
        // const idx = codes.indexOf('UAH')
        this.currentToken = value || null
          // codes[idx !== -1 && idx < codes.length ? idx : 0] ||
          // null
        this.commitAsset(this.currentToken)
        this.loadBalances()
      },
      walletTopUpHandler (e) {
        this.currentActiveOperationWidget = OPERATIONS_WIDGETS.MAKE_TOPUP
      },
      wizdrawalHandler (e) {
        this.currentActiveOperationWidget = OPERATIONS_WIDGETS.WIZDRAWAL
      }
    }
  }
</script>

<style lang="scss" scoped>
.new-dashboard {
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  grid-template-rows: 430px auto;
  grid-column-gap: 20px;
  grid-row-gap: 20px;
  min-height: calc(100vh - 100px);

  &__wallet-widget{
    grid-area: 1/1/2/5;
  }

  &__operations-widget {
    grid-area: 1/5/2/9;
  }

  &__chart-widget {
    grid-area: 1 / 9 / 2 / 13;
  }

  &__history-widget {
    grid-area: 2 / 1 / 3 / 13;
  }
}
</style>



// WEBPACK FOOTER //
// src/vue/app/dashboard/index/Dashboard.Index.vue